module.exports = __webpack_public_path__ + "static/apple-touch-icon-152x152-1f5fc624e0aa3e6e1e08306e92cfde57.png";